export default "__VITE_ASSET__BY3GtRGF__"